import { Injectable } from '@angular/core';
import { Icon, IconName } from './build';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  private registry: Map<IconName, Icon> = new Map();

  register(icons: Icon[][] | null): void {
    for (const iconBatch of icons ?? []) {
      for (const icon of iconBatch) {
        this.registry.set(icon.name, icon);
      }
    }
  }

  get(name: IconName): Icon | null {
    return this.registry.get(name) ?? null;
  }
}
